import { formatDate } from '../../utils';
import './templateListItem.scss';

// for templates list on templates page
const templateListItem = i => `<div class="testimonial__item">
  <div class="testimonial__item__date">${formatDate(i.createdAt)}</div>
    <div class="testimonial__item__body">"${i.body}"</div>
    <div class="testimonial__item__footer">
      <div class="testimonial__item__id">Customer ID: #${i.customerId}XXX</div>
      <div class="testimonial__item__topic">Topic title: ${i.orderTopic}</div>
      <div class="testimonial__item__discipline">Discipline: ${i.orderDiscipline}</div>
      <div class="testimonial__item__pages">Pages: ${i.orderPages}</div>
    </div>
  </div>`;

export default templateListItem;
